<template>
    <div class="home-container pb-5">
        <section class="activities-section d-flex flex-column align-items-center gap-4">
            <div class="d-flex flex-column flex-xxl-row align-items-start gap-2 align-items-xxl-center justify-content-xxl-between gap-xxl-5 w-100">
                <h4 class="extra-large-text light-black-color">აქტივობები</h4>
                <div class="common-secondary-search-container">
                    <form class="search-form" @submit.prevent="submitActivitiesFilters()"> 
                        <input name="search-input" v-model="activitiesFiltersInfoObj.search" id="search-input" type="text" class="primary-input extra-light-text" placeholder="ძებნა"/>
                        <fieldset class="d-flex w-100 justify-content-end gap-2 align-items-center">
                            <Multiselect v-for="(data, i) of activitiesDateSortMultiselectArray" name="ageRangeID" id="ageRangeID" v-model="activitiesFiltersInfoObj.dateSort" :options="data.options" :mode="data.mode"
                                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                                :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="false"
                                class="extra-light-text light-blue-color custom-multiselect" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
                            <button type="submit" class="extra-light-text extra-green-color ms-2" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button>
                        </fieldset>
                    </form>
                </div>
                <secondaryButton buttonType="button" class="large-text font-weight-600" buttonWidth="max-content" paddingX="15px" @click="activateModalMode('addActivity', true)">
                    <template v-slot:content>
                        <p>ახალი აქტივობა</p>
                    </template>
                </secondaryButton>
            </div>
            
            <div class="common-news-activities-survey-grid-container w-100">
                <shortInfoBlock v-if="activitiesArray.length > 5" class="common-box-shadow w-100" v-for="(data, i) of activitiesArray">
                    <template v-slot:mainPart>
                        <div class="d-flex align-items-start gap-3">
                            <div style="width: 60px; height: 60px;"> 
                                <img style="width: 60px; height: 60px; object-fit: contain;" :src="data?.news_photo?`data:image/jpeg;base64,${data.news_photo}`:null" alt="empty">
                            </div>
                            <h6 class="large-text text-start newsOrActivityTitle" v-html="data.title"></h6>
                        </div>
                    </template>
                    <template v-slot:rightTopPart>
                        <button @click="fillCorrectInfoVmodels(data), activateModalMode('correctActivity', true)">
                            <img src="@/assets/images/correctionButton.svg" alt="correction Button">
                        </button>
                        <button @click="deleteClickHandler(data.newsID), activateModalMode('deleteActivity', true)">
                            <img src="@/assets/images/tableDeleteButton.svg" alt="delete button">
                        </button>
                    </template>
                    <template v-slot:rightBottomPart>
                        <primaryButtonComponent @click="seeNewsHandler(data), activateModalMode('seeActivity', true)" buttonType="button" buttonWidth="max-content" paddingX="32px" paddingY="8px">
                            <template v-slot:content>
                                <p class="light-text font-weight-600">ნახვა</p>
                            </template>
                        </primaryButtonComponent>
                    </template>
                    <template v-slot:subPart>
                        <p class="light-text extra-gray-color text-start">გამოქვეყნებული: <span>{{ data.publish_date }}</span></p>
                    </template>
                </shortInfoBlock>
                <template v-else v-for="(num, i) of [1, 2, 3, 4, 5, 6]">
                    <shortInfoBlock class="common-box-shadow w-100" :isDisabled="!activitiesArray[i]">
                        <template v-slot:mainPart>
                            <div class="d-flex align-items-start gap-3">
                                <div style="width: 60px; height: 60px;">
                                    <img style="width: 60px; height: 60px; object-fit: contain;" :src="activitiesArray[i]?.news_photo?`data:image/jpeg;base64,${activitiesArray[i].news_photo}`:null" alt="empty">
                                </div>
                                <h6 v-if="activitiesArray[i]?.title" v-html="activitiesArray[i]?.title" class="large-text text-start newsOrActivityTitle"></h6>
                                <h6 v-else class="large-text font-weight-600 text-start">--------------</h6>
                            </div>
                        </template>
                        <template v-slot:rightTopPart>
                            <button v-if="activitiesArray[i]" @click="fillCorrectInfoVmodels(activitiesArray[i]), activateModalMode('correctActivity', true)">
                                <img src="@/assets/images/correctionButton.svg" alt="correction Button">
                            </button>
                            <button v-else>
                                <img src="@/assets/images/correctionButton.svg" alt="correction Button">
                            </button>
                            <button v-if="activitiesArray[i]" @click="deleteClickHandler(activitiesArray[i].newsID), activateModalMode('deleteActivity', true)">
                                <img src="@/assets/images/tableDeleteButton.svg" alt="delete button">
                            </button>
                            <button v-else>
                                <img src="@/assets/images/tableDeleteButton.svg" alt="delete button">
                            </button>
                        </template>
                        <template v-slot:rightBottomPart>
                            <primaryButtonComponent v-if="activitiesArray[i]" @click="seeNewsHandler(activitiesArray[i]), activateModalMode('seeActivity', true)" buttonType="button" buttonWidth="max-content" paddingX="32px" paddingY="8px">
                                <template v-slot:content>
                                    <p class="light-text font-weight-600">ნახვა</p>
                                </template>
                            </primaryButtonComponent>
                            <primaryButtonComponent v-else buttonType="button" buttonWidth="max-content" paddingX="32px" paddingY="8px">
                                <template v-slot:content>
                                    <p class="light-text font-weight-600">ნახვა</p>
                                </template>
                            </primaryButtonComponent>
                        </template>
                        <template v-slot:subPart>
                            <p class="light-text extra-gray-color text-start">გამოქვეყნებული: <span>{{ (activitiesArray[i]?.publish_date)??"--------------" }}</span></p>
                        </template>
                    </shortInfoBlock>
                </template>
            </div>
            <vue-awesome-paginate
                :total-items="activitiesPagingInfo.total"
                :items-per-page="activitiesPagingInfo.limit"
                :max-pages-shown="4"
                v-model="activitiesPagingInfo.offset"
                :hide-prev-next-when-ends="false"
                @click="activitiesPaginationClickHandler"
                class="my-3"
            />
        </section>
        <section class="news-section d-flex flex-column align-items-center gap-4">
            <div class="d-flex flex-column flex-xxl-row align-items-start gap-2 align-items-xxl-center justify-content-xxl-between gap-xxl-5 w-100">
                <h4 class="extra-large-text light-black-color">სიახლეები</h4>
                <div class="common-secondary-search-container">
                    <form class="search-form" @submit.prevent="submitNewsFilters()">
                        <input name="search-input" v-model="newsFiltersInfoObj.search" id="search-input" type="text" class="primary-input extra-light-text" placeholder="ძებნა"/>
                        <fieldset class="d-flex w-100 justify-content-end gap-2 align-items-center">
                            <Multiselect v-for="(data, i) of newsDateSortMultiselectArray" name="dateSort" id="dateSort" v-model="newsFiltersInfoObj.dateSort" :options="data.options" :mode="data.mode"
                                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                                :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="false"
                                class="extra-light-text light-blue-color custom-multiselect" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
                            <button type="submit" class="extra-light-text extra-green-color ms-2" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button>
                        </fieldset>
                    </form>
                </div>
                <secondaryButton buttonType="button" class="large-text font-weight-600" buttonWidth="max-content" paddingX="15px" @click="activateModalMode('addNews', true)">
                    <template v-slot:content>
                        <p>ახალი სიახლე</p>
                    </template>
                </secondaryButton>
            </div>
            <div class="common-news-activities-survey-grid-container w-100">
                <shortInfoBlock v-if="newsArray.length > 5" class="common-box-shadow w-100" v-for="(data, i) of newsArray">
                    <template v-slot:mainPart>
                        <div class="d-flex align-items-start gap-3">
                            <div style="width: 60px; height: 60px;">
                                <img style="width: 60px; height: 60px; object-fit: contain;" :src="data?.news_photo?`data:image/jpeg;base64,${data.news_photo}`:null" alt="empty">
                            </div>
                            <h6 class="large-text text-start newsOrActivityTitle" v-html="data.title"></h6>
                        </div>
                    </template>
                    <template v-slot:rightTopPart>
                        <button @click="fillCorrectInfoVmodels(data), activateModalMode('correctNews', true)">
                            <img src="@/assets/images/correctionButton.svg" alt="correction Button">
                        </button>
                        <button @click="deleteClickHandler(data.newsID), activateModalMode('deleteNews', true)">
                            <img src="@/assets/images/tableDeleteButton.svg" alt="delete button">
                        </button>
                    </template>
                    <template v-slot:rightBottomPart>
                        <primaryButtonComponent @click="seeNewsHandler(data), activateModalMode('seeNews', true)" buttonType="button" buttonWidth="max-content" paddingX="32px" paddingY="8px">
                            <template v-slot:content>
                                <p class="light-text font-weight-600">ნახვა</p>
                            </template>
                        </primaryButtonComponent>
                    </template>
                    <template v-slot:subPart>
                        <p class="light-text extra-gray-color text-start">გამოქვეყნებული: <span>{{ data.publish_date }}</span></p>
                    </template>
                </shortInfoBlock>
                <template v-else v-for="(num, i) of [1, 2, 3, 4, 5, 6]">
                    <shortInfoBlock class="common-box-shadow w-100" :isDisabled="!newsArray[i]">
                        <template v-slot:mainPart>
                            <div class="d-flex align-items-start gap-3">
                                <div style="width: 60px; height: 60px;">
                                    <img style="width: 60px; height: 60px; object-fit: contain;" :src="newsArray[i]?.news_photo?`data:image/jpeg;base64,${newsArray[i].news_photo}`:null" alt="empty">
                                </div>
                                <h6 v-if="newsArray[i]?.title" class="large-text text-start newsOrActivityTitle" v-html="newsArray[i]?.title"></h6>
                                <h6 v-else class="large-text font-weight-600 text-start">--------------</h6>
                            </div>
                        </template>
                        <template v-slot:rightTopPart>
                            <button v-if="newsArray[i]" @click="fillCorrectInfoVmodels(newsArray[i]), activateModalMode('correctNews', true)">
                                <img src="@/assets/images/correctionButton.svg" alt="correction Button">
                            </button>
                            <button v-else>
                                <img src="@/assets/images/correctionButton.svg" alt="correction Button">
                            </button>
                            <button v-if="newsArray[i]" @click="deleteClickHandler(newsArray[i].newsID), activateModalMode('deleteNews', true)">
                                <img src="@/assets/images/tableDeleteButton.svg" alt="delete button">
                            </button>
                            <button v-else>
                                <img src="@/assets/images/tableDeleteButton.svg" alt="delete button">
                            </button>
                        </template>
                        <template v-slot:rightBottomPart>
                            <primaryButtonComponent v-if="newsArray[i]" @click="seeNewsHandler(newsArray[i]), activateModalMode('seeNews', true)" buttonType="button" buttonWidth="max-content" paddingX="32px" paddingY="8px">
                                <template v-slot:content>
                                    <p class="light-text font-weight-600">ნახვა</p>
                                </template>
                            </primaryButtonComponent>
                            <primaryButtonComponent v-else buttonType="button" buttonWidth="max-content" paddingX="32px" paddingY="8px">
                                <template v-slot:content>
                                    <p class="light-text font-weight-600">ნახვა</p>
                                </template>
                            </primaryButtonComponent>
                        </template>
                        <template v-slot:subPart>
                            <p class="light-text extra-gray-color text-start">გამოქვეყნებული: <span>{{ (newsArray[i]?.publish_date)??"--------------" }}</span></p>
                        </template>
                    </shortInfoBlock>
                </template>
            </div>
            <vue-awesome-paginate
                :total-items="newsPagingInfo.total"
                :items-per-page="newsPagingInfo.limit"
                :max-pages-shown="4"
                v-model="newsPagingInfo.offset"
                :hide-prev-next-when-ends="false"
                @click="newsPaginationClickHandler"
                class="my-3"
            />
        </section>
    </div>
    <primaryModalComponent :showModal="showModal" maxHeight="781px" maxWidth="1024px" @closeModal="triggerModal">
        <template v-slot:modal-content>
            <div class="d-flex flex-column align-items-stretch gap-4">
                <h5 class="extra-large-text">
                    {{ `${modalTitle}` }}
                </h5>
                <div v-if="modalMode == 'deleteNews' || modalMode == 'deleteActivity'" class="d-flex align-items-center justify-content-center gap-3">
                    <primaryButtonComponent @click="deleteNewsHandler()" buttonType="button" buttonWidth="min-content" class="large-text mt-4">
                        <template v-slot:content>
                            წაშლა
                        </template>
                    </primaryButtonComponent>
                    <primaryButtonComponent @click="triggerModal(false)" :mode="1" buttonType="button" buttonWidth="min-content" class="large-text mt-4">
                        <template v-slot:content>
                            გაუქმება
                        </template>
                    </primaryButtonComponent>
                </div>
                <form ref="addOrCorrectForm" v-if="modalMode == 'addActivity' || modalMode == 'addNews' || modalMode == 'correctActivity' || modalMode == 'correctNews'" @submit.prevent="addOrCorrectNewsHandler" class="add-or-correct-form modal-form-grid-wrapper w-100" style="align-items: center;">
                    <fieldset v-if="modalMode.startsWith('correct')" style="width: 100%; height: min-content; grid-column: 1 / 2; grid-row: 1 / 3; max-height: 220px; height: 100%;" class="d-flex align-items-stretch justify-content-stretch">
                        
                        <mediaShowDownload :showDownloadButton="false" :showDeleteButton="false" :photoURl="openedNews.photo?`data:image/jpeg;base64,${openedNews.photo}`:null"/>
                    </fieldset>
                    <fieldset :class="[{'red-border': isTitleSet === false && isTitleengSet === false}]" class="d-flex flex-column align-items-start gap-1 light-text w-100">
                        <h6 class="ms-2 light-gray-color">სათაური(ქართულად)</h6>
                        <div id="title" class="newsOrActivityTitle" style="width: 100%; height: 100%;"></div>
                    </fieldset>
                    <fieldset :class="[{'red-border': isTitleSet === false && isTitleengSet === false}]" class="d-flex flex-column align-items-end gap-1 light-text">
                        <h6 class="me-2 light-gray-color">(ინგლისურად)სათაური</h6>
                        <div id="titleeng" class="newsOrActivityTitle" style="width: 100%; height: 100%;"></div>
                    </fieldset>
                    <fieldset :class="[{'red-border': isBodyTextSet === false && isBodyTextengSet === false}]" class="d-flex flex-column align-items-start gap-1 light-text">
                        <h6 class="ms-2 light-gray-color">აღწერა(ქართულად)</h6>
                        <div id="body_text" class="newsOrActivityTitle" style="width: 100%; height: 100%;"></div>
                    </fieldset>
                    <fieldset :class="[{'red-border': isBodyTextSet === false && isBodyTextengSet === false}]" class="d-flex flex-column align-items-end gap-1 light-text">
                        <h6 class="me-2 light-gray-color">(ინგლისურად)აღწერა</h6>
                        <div id="body_texteng" class="newsOrActivityTitle" style="width: 100%; height: 100%;"></div>
                    </fieldset>
                    <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                        <label v-if="modalMode.startsWith('add')" for="news_date" class="ms-2">{{modalMode == "addActivity"?"აქტივობის თარიღი":"სიახლის თარიღი"}}</label>
                        <label v-else-if="modalMode.startsWith('correct')" for="news_date" class="ms-2">{{modalMode == "correctActivity"?"აქტივობის თარიღი":"სიახლის თარიღი"}}</label>
                        <input type="date" v-model="addOrCorrectNews.news_date" autocomplete="off" name="news_date" id="news_date" required :placeholder="modalMode == 'addActivity'?'აქტივობის თარიღი':'სიახლის თარიღი'" class="blue-part-input large-text">
                    </fieldset>
                    <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
                        <label for="activityOrNewsPhoto" class="ms-2">(jpg, png)ფოტო</label>
                        <input ref="activityOrNewsPhoto" type="file" accept="image/jpeg, image/png, image/jpg" autocomplete="off" name="activityOrNewsPhoto" id="activityOrNewsPhoto" :required="modalMode.startsWith('add')?true:false" class="blue-part-input large-text">
                    </fieldset>
                    <fieldset class="d-flex align-items-start gap-1 light-gray-color light-text">
                        <input type="checkbox" v-model="addOrCorrectNews.is_main" autocomplete="off" name="isMain" id="isMain" class="blue-part-input large-text">
                        <label for="isMain">მოინიშნოს როგორც მთავარი</label>
                    </fieldset>
                    <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text" style="grid-column: 1 / 3;">
                        <label for="tags" class="ms-2">tags</label>
                        <div class="d-flex w-100">
                            <input ref="tagInput" v-model="addTagInputVal" @keydown="addTag" type="text" autocomplete="off" name="tags" id="tags" placeholder="tags" class="blue-part-input large-text" style="max-width: 150px;"/>
                            <Multiselect v-model="addOrCorrectNews.tags" :options="this.tagsMultiselectArray[0].options" :mode="this.tagsMultiselectArray[0].mode"
                                :searchable="false" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                                :hideSelected="true" id="tagsContainer" :caret="false"
                                class="extra-light-text light-blue-color w-100 with-no-options" autocomplete="off" :placeholder="this.tagsMultiselectArray[0].placeholder" :disabled="this.tagsMultiselectArray[0].isDisabled" insert
                                @deselect = "deselectTag" @clear="clearTags"/>
                        </div>
                    </fieldset>
                    <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text" style="grid-column: 1 / 3;">
                        <label for="links" class="ms-2">links</label>
                        <div class="d-flex w-100">
                            <Multiselect v-for="(data, i) of linksMultiselectArray" v-model="data.vmodel" name="linksOptions" id="linksOptions" :options="data.options" :mode="data.mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="false"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
                            
                            <input ref="linksInput" @keydown="addLink" v-model="addLinkInputVal" type="text" autocomplete="off" name="links" id="links" placeholder="ლინკი" class="blue-part-input large-text"/>

                        </div>
                        <Multiselect v-model="addOrCorrectNews.news_links" :options="this.choosenLinksMultiselectArray[0].options" :mode="this.choosenLinksMultiselectArray[0].mode"
                            :searchable="false" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" id="tagsContainer" :caret="false"
                            class="extra-light-text light-blue-color w-100 with-no-options" autocomplete="off" :placeholder="this.choosenLinksMultiselectArray[0].placeholder" :disabled="this.choosenLinksMultiselectArray[0].isDisabled" insert
                            @deselect = "deselectLinks" @clear="clearLinks"/>
                    </fieldset>
                    <div class="button-wrapper d-flex justify-content-center w-100">
                        <secondaryButton buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                            <template v-slot:content>
                                {{modalMode == 'correctActivity' || modalMode == 'correctNews'?'რედაქტირება':'დამატება'}}
                            </template>
                        </secondaryButton>
                    </div>
                </form>
                <ul v-if="modalMode == 'seeNews' || modalMode == 'seeActivity'" class="see-news-modal-form-grid-wrapper w-100">
                    <li style="width: 100%; height: min-content; max-height: 220px; height: 100%;" class="d-flex flex-column align-items-stretch justify-content-stretch">
                        <h6 class="light-gray-color light-text">{{seeNewsVmodelsObj.is_main?"მოინიშნულია როგორც მთავარი":""}}</h6>
                        <mediaShowDownload :showDownloadButton="false" :showDeleteButton="false" :photoURl="seeNewsVmodelsObj.news_photo?`data:image/jpeg;base64,${seeNewsVmodelsObj.news_photo}`:null"/>
                    </li>
                    <li class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                        <h6 class="ms-2">სათაური(ქართულად)</h6>
                        <div v-html="seeNewsVmodelsObj.title" class="blue-part-input see-news-field text-start large-text newsOrActivityTitle"></div>
                    </li>
                    <li class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                        <h6 class="me-2">სათაური(ინგლისურად)</h6>
                        <div v-html="seeNewsVmodelsObj.titleeng" class="blue-part-input see-news-field text-start large-text newsOrActivityTitle"></div>
                    </li>
                    <li class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
                        <h6 class="ms-2">აღწერა(ქართულად)</h6>
                        <div v-html="seeNewsVmodelsObj.body_text" class="blue-part-input see-news-field text-start large-text newsOrActivityTitle"></div>
                    </li>
                     <li class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
                        <h6 class="me-2">(ინგლისურად)აღწერა</h6>
                        <div v-html="seeNewsVmodelsObj.body_texteng" class="blue-part-input see-news-field text-start large-text newsOrActivityTitle"></div>
                    </li>
                    <li class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
                        <h6 class="ms-2">თარიღი yyyy.mm.dd</h6>
                        <div class="blue-part-input see-news-field text-start large-text">{{ seeNewsVmodelsObj.news_date }}</div>
                    </li>
                    
                    <li class="d-flex flex-column align-items-start gap-1 light-text" style="grid-column: 1 / 3;">
                        <h6 class="ms-2 before-extra-large-text">tags</h6>
                        <ul class="d-flex gap-2 align-items-center w-100 flex-wrap">
                            <li v-if="seeNewsVmodelsObj?.tags?.split(',').length > 4" v-for="(tags, i) of seeNewsVmodelsObj?.tags?.split(',')">
                                <p class="tags-and-links">{{ tags }}</p>
                            </li>
                            <li v-else v-for="(num, i) of [1, 2, 3, 4]">
                                <p :class="['tags-and-links', {'default': !seeNewsVmodelsObj?.tags?.split(',')[i]}]">{{ seeNewsVmodelsObj?.tags?.split(',')[i]??"----------" }}</p>
                            </li>
                        </ul>
                    </li>
                    <li class="d-flex flex-column align-items-start gap-1 light-text" style="grid-column: 1 / 3;">
                        <h6 class="ms-2 before-extra-large-text">links</h6>
                        <ul class="d-flex gap-2 align-items-center w-100 flex-wrap">
                            <li class="tags-and-links d-flex align-items-center gap-2" v-if="seeNewsVmodelsObj.news_links.length> 4" v-for="(linkObj, i) of seeNewsVmodelsObj.news_links">
                                <span>{{ linkObj.link_types.link_type?`${linkObj.link_types.link_type}: `:"" }}
                                </span>
                                <a style="color: var(--secondary-background-color);" target="_blank" :href="linkObj?.news_link??''" v-if="seeNewsVmodelsObj?.news_links[i]?.news_link">{{ linkObj.news_link }}</a>
                            </li>
                            <li v-else :class="['tags-and-links', {'default': !seeNewsVmodelsObj?.news_links[i]}, 'd-flex', 'justify-content-between']" v-for="(num, i) of [1, 2, 3, 4]">
                                <span>{{ seeNewsVmodelsObj?.news_links[i]?.link_types?.link_type?`${seeNewsVmodelsObj.news_links[i].link_types.link_type}: `:"----------" }}
                                </span>
                                <a style="color: var(--secondary-background-color); text-align: left;" target="_blank" :href="seeNewsVmodelsObj?.news_links[i]?.news_link??''" v-if="seeNewsVmodelsObj?.news_links[i]?.news_link">{{ seeNewsVmodelsObj?.news_links[i]?.news_link }}</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </template>
    </primaryModalComponent>
</template>
<script>
import searchFilterBarComponent from '@/components/search-filterBarComponent.vue';
import secondaryButton from '@/components/secondaryButton.vue';
import shortInfoBlock from '@/components/shortInfoBlock.vue';
import primaryModalComponent from '@/components/primaryModalComponent.vue';
import Multiselect from '@vueform/multiselect';
import primaryButtonComponent from '@/components/primaryButtonComponent.vue';
import mediaShowDownload from '@/components/mediaShowDownload.vue';
import Quill from 'quill';

export default {
    data(){
        return {
            addOrCorrectQuillTitle: null,
            addOrCorrectQuillTitleeng: null,
            addOrCorrectQuillBodyText: null,
            addOrCorrectQuillBodyTexteng: null,

            // for activites cards >>
            linkTypes: [],
            activitiesArray: [],
            newsArray: [],
            // for filters >>
            activatedFilterMode: 0,
            filteringPagingInfo: {
                activitiessearch: "",
                activitiesdateSort: null,
                activitiesOffset: null,

                newssearch: "",
                newsdateSort: null,
                newsOffset: null,
            },
            // for activity filters >>
            activitiesFiltersInfoObj: {
                search: "",
                dateSort: null,
            },
            activitiesPagingInfo: {
                limit: 6,
                offset: 1,
                total: 0,
            },
            activitiesDateSortMultiselectArray: [
                {
                    placeholder: "სორტირება თარიღით",
                    options: [
                        {
                            value: 1,
                            label: {
                                ge: "თარიღი კლებადობით",
                                en: "date descending",
                            }
                        },
                        {
                            value: 2,
                            label: {
                                ge: "თარიღი ზრდადობით",
                                en: "date ascending",
                            }
                        },
                    ],
                    mode: "single",
                    isDisabled: false,
                },
            ],
            // for news filters >>
            newsFiltersInfoObj: {
                search: "",
                dateSort: null,
            },
            newsPagingInfo: {
                limit: 6,
                offset: 1,
                total: 0,
            },
            newsDateSortMultiselectArray: [
                {
                    placeholder: "სორტირება თარიღით",
                    options: [
                        {
                            value: 1,
                            label: {
                                ge: "თარიღი კლებადობით",
                                en: "date descending",
                            }
                        },
                        {
                            value: 2,
                            label: {
                                ge: "თარიღი ზრდადობით",
                                en: "date ascending",
                            }
                        },
                    ],
                    mode: "single",
                    isDisabled: false,
                },
            ],
            // << for filters
            // for modal >>
            showModal: false,
            modalTitle: "",
            modalSubTitle: "",
            addOrCorrectNews: {
                title: null,
                titleeng: null,
                body_text: null,
                body_texteng: null,
                news_date: null,
                is_main: false,
                tags: [],
                news_links: [],
            },
            isTitleSet: null,
            isTitleengSet: null,
            isBodyTextSet: null,
            isBodyTextengSet: null,
            openedNews: {
                openedNewsID: null,
                photo: null,
            },
            // for seeNews Mode >>
            seeNewsVmodelsObj: {},

            // for add and correct sections >>
            // for tags section in modal>>
            tagsMultiselectArray: [
                {
                    placeholder: "empty",
                    options: [],
                    mode: "tags",
                    isDisabled: false,
                }
            ],
            addTagInputVal: null,
            // for links section  in modal>>
            linksMultiselectArray: [
                {
                placeholder: "ლინკის ტიპი",
                options: [],
                vmodel: null,
                mode: "single",
                isDisabled: false,
                },
            ],
            addLinkInputVal: null,
            choosenLinksMultiselectArray: [
                {
                    placeholder: "empty",
                    options: [],
                    mode: "tags",
                    isDisabled: false,
                }
            ],
        }
    },
    components: {
        searchFilterBarComponent,
        secondaryButton,
        shortInfoBlock,
        primaryModalComponent,
        Multiselect,
        primaryButtonComponent,
        mediaShowDownload,
    },
    beforeRouteUpdate(to, from, next){
        let isQueriesValid = this.getInfoFromRoute(to);
        
        if(isQueriesValid){
            if(this.activatedFilterMode == 0){
                this.manageActivitiesFilters();
                this.manageNewsFilters();
            }else if(this.activatedFilterMode == 1){
                this.manageActivitiesFilters();
            }else if(this.activatedFilterMode == 2){
                this.manageNewsFilters();
            }
            next(true);
        }else{
            next(false);
            this.$helper.showSwal("არასწორი მისამართი", "error", "");
        }
        this.activatedFilterMode = 0;
    },
    mounted() {
        this.routerMountMovement(this.$route);
        
    },
    methods: {
        routerMountMovement(to){
            let isQueriesValid = this.getInfoFromRoute(to);
        
            if(isQueriesValid){
                this.getLinkTypes();
                this.manageActivitiesFilters();
                this.manageNewsFilters();
            }else{
                this.$router.replace(this.$route.path);
                this.$helper.showSwal("არასწორი მისამართი", "error", "");
            }
            this.activatedFilterMode = 0;
        },
        getInfoFromRoute(to){
            Object.keys(this.filteringPagingInfo).forEach((key) => {
                this.filteringPagingInfo[key] = to.query[key]?decodeURIComponent(to.query[key].replace(/%/g, '%25')):null;
            })
            
            let isQueriesValid = Object.keys(this.filteringPagingInfo).every((key) => {
                if(key == "activitiessearch" || key == "newssearch"){
                    return this.$helper.checkJustOptionalString(this.filteringPagingInfo[key]??"");
                }else if(this.filteringPagingInfo[key] == null){
                    return true;
                }else{
                    return this.$helper.checkOptionalNumber(this.filteringPagingInfo[key]);
                }
            });
            
            return isQueriesValid;
        },
        deleteClickHandler(newsID){
            this.openedNews.openedNewsID = newsID;
        },
        deleteNewsHandler(){
            let word;
            if(this.modalMode == "deleteNews"){
                word = "სიახლე";
            }else if(this.modalMode == "deleteActivity"){
                word = "აქტივობა";
            }
            
            this.$store.dispatch("deleteNews", this.openedNews.openedNewsID).then((response) => {
                
                if(response.status == 200){
                    this.$helper.showSwal(`${word} წარმატებით წაიშალა`, "success", "");
                    this.triggerModal(false);
                    if(this.activitiesPagingInfo.offset == 1 && this.newsPagingInfo.offset == 1){
                        this.getActivities();
                        this.getNews();
                    }else{
                        this.$router.push({
                            path: this.$route.path,
                            query: {
                                ...this.$route.query, 
                                activitiesOffset: 0,
                                newsOffset: 0,
                            }
                        });
                    }
                }
            }).catch((error) => {
                this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                setTimeout(() => {this.$router.go()}, 1500);
            });
        },
        seeNewsHandler(data){
            this.seeNewsVmodelsObj = data;
        },
        fillCorrectInfoVmodels(data){
            Object.keys(this.addOrCorrectNews).forEach((key) => {
                if(key == "news_links"){
                    if(data[key]){
                        data.news_links.forEach((dataLinkObj) => {
                            this.choosenLinksMultiselectArray[0].options.push({
                                link_typeID: dataLinkObj.link_typeID,
                                value: dataLinkObj.news_link,
                                label: `${dataLinkObj.link_types.link_type} : ${dataLinkObj.news_link}`,
                            });
                            this.addOrCorrectNews.news_links.push(dataLinkObj.news_link);
                        });
                    }else{
                        this.choosenLinksMultiselectArray[0].options = [];
                        this.addOrCorrectNews.news_links = [];
                    }
                }else if(key == "tags"){
                    if(data[key]){
                        data[key]?.split(",").forEach((tagStr) => {
                            this.tagsMultiselectArray[0].options.push({
                                label: tagStr,
                                value: tagStr,
                            });
                        });
                        this.addOrCorrectNews[key] = data[key]?.split(",");
                    }else{
                        this.tagsMultiselectArray[0].options = [];
                        this.addOrCorrectNews[key] = [];
                    }
                    
                    
                }else if(key == "is_main"){
                    this.addOrCorrectNews[key] = data[key] == 0?false:true;
                }else{
                    this.addOrCorrectNews[key] = data[key];
                }
                
            });
            this.openedNews.openedNewsID = data.newsID;
            this.openedNews.photo = data.news_photo;
            
            
            
        },
        activateModalMode(modalMode, isOpen){
            if(modalMode == "addActivity"){
                this.modalTitle = "დაამატეთ აქტივობა";
            }else if(modalMode == "addNews"){
                this.modalTitle = "დაამატეთ სიახლე";
            }else if(modalMode == "correctActivity"){
                this.modalTitle = "ჩაასწორეთ აქტივობა";
            }else if(modalMode == "correctNews"){
                this.modalTitle = "ჩაასწორეთ სიახლე";
            }else if(modalMode == "deleteActivity"){
                this.modalTitle = "ნამდვილად გსურთ წაშლა?";
            }else if(modalMode == "deleteNews"){
                this.modalTitle = "ნამდვილად გსურთ წაშლა?";
            }else if(modalMode == "seeActivity"){
                this.modalTitle = "დეტალურად აქტივობა";
            }else if(modalMode == "seeNews"){
                this.modalTitle = "დეტალურად სიახლე";
            }
            this.modalMode = modalMode;
            this.triggerModal(isOpen);
            setTimeout(() => {
                let confObj = {
                    debug: 'info',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            [{ size: [ 'small', false, 'large' ]}]
                        ]
                    },
                    placeholder: 'სათაური ქართულად',
                    theme: 'snow'
                };
                this.removeAriaHidden();
                if(modalMode == "addActivity" || modalMode == "addNews" || modalMode == "correctActivity" || modalMode == "correctNews"){
                    this.addOrCorrectQuillTitle = new Quill('#title', confObj);
                    this.addOrCorrectQuillTitle.root.innerHTML = this.addOrCorrectNews.title;
                    
                    this.addOrCorrectQuillTitleeng = new Quill('#titleeng', {...confObj, placeholder: "სათაური ინგლისურად"});
                    this.addOrCorrectQuillTitleeng.root.innerHTML = this.addOrCorrectNews.titleeng;

                    this.addOrCorrectQuillBodyText = new Quill('#body_text', {...confObj, placeholder: "აღწერა ქართულად"});
                    this.addOrCorrectQuillBodyText.root.innerHTML = this.addOrCorrectNews.body_text;

                    this.addOrCorrectQuillBodyTexteng = new Quill('#body_texteng', {...confObj, placeholder: "აღწერა ინგლისურად"});
                    this.addOrCorrectQuillBodyTexteng.root.innerHTML = this.addOrCorrectNews.body_texteng;
                }
            }, 0);
        },
        triggerModal(Val){
            
            if(Val == false){
                Object.keys(this.addOrCorrectNews).forEach((key) => {
                    if(key == "tags" ){
                        this.addOrCorrectNews[key] = [];
                        this.tagsMultiselectArray[0].options = [];
                        this.addTagInputVal = "";
                    }else if(key == "news_links"){
                        this.addOrCorrectNews[key] = [];
                        this.choosenLinksMultiselectArray[0].options = [];
                        this.linksMultiselectArray[0].vmodel = null;
                        this.addLinkInputVal = "";
                    }else if(key == "is_main"){
                        this.addOrCorrectNews[key] = false;
                    }
                    else{
                        this.addOrCorrectNews[key] = null;
                    }
                });
                Object.keys(this.openedNews).forEach((key) => {
                    this.openedNews[key] = null;
                });
                this.seeNewsVmodelsObj = {};
                this.isTitleSet = null;
                this.isTitleengSet = null;
                this.isBodyTextSet = null;
                this.isBodyTextengSet = null;
            }


            this.showModal = Val;

        },
        deselectTag(val){
            let optionIndexToDeselect = this.tagsMultiselectArray[0].options.findIndex((option) => {
                if(option.value == val){
                    return true;
                }else{
                    return false;
                }
            });
            this.tagsMultiselectArray[0].options.splice(optionIndexToDeselect, 1);

            
            this.addTagInputVal = "";
        },
        clearTags(){
            this.tagsMultiselectArray[0].options = [];
            this.addTagInputVal = "";
        },
        addTag(event){
            if(event.code == "Enter" || event.code == "NumpadEnter"){
                event.preventDefault();
            }

            if((event.code == "Enter" || event.code == "NumpadEnter") && this?.addTagInputVal?.trim() && this.$helper.checkJustString(this?.addTagInputVal?.trim())){
                let newVal = this.addTagInputVal.trim();
                
                if(!this.addOrCorrectNews.tags?.includes(newVal)){
                    this.tagsMultiselectArray[0].options.push({
                        label: newVal,
                        value: newVal,
                    });
                    this.addOrCorrectNews.tags?.push(newVal);
                    
                    
                }

                this.addTagInputVal = "";
            }else if(event.code == "Enter" || event.code == "NumpadEnter"){
                this.addTagInputVal = "";
            }
        },
        addLink(event){
            if(event.code == "Enter"){
                event.preventDefault();
            }
            // if(event.code == "Enter" && this?.addLinkInputVal?.trim() && this.linksMultiselectArray[0].vmodel && this?.addLinkInputVal?.startsWith("https://www.")){ **<>
            
            if(event.code == "Enter" && this.$helper.sanitazeAndPermitURI(this?.addLinkInputVal?.trim()) && this.linksMultiselectArray[0].vmodel){
                // let newVal = this.addLinkInputVal.trim(); **<>
                let newVal = this.$helper.decodeHtml(this.$helper.sanitazeAndPermitURI(this?.addLinkInputVal?.trim()));

                let isIncluded = this.addOrCorrectNews.news_links.find((linkItem) => {
                    return linkItem == newVal;
                });

                if(!isIncluded){
                    let linkTypeToBeAdded = this.linkTypes.find((linkTypeObj) => {
                        return linkTypeObj.link_typeID == this.linksMultiselectArray[0].vmodel;
                    });
                    this.choosenLinksMultiselectArray[0]?.options?.push({
                        link_typeID: this.linksMultiselectArray[0].vmodel,
                        value: newVal,
                        label: `${linkTypeToBeAdded.link_type} : ${newVal}`,
                    });
                    this.addOrCorrectNews?.news_links?.push(newVal);
                }
                this.addLinkInputVal = "";
            }
        },
        clearLinks(){
            this.choosenLinksMultiselectArray[0].options = [];
            this.addLinkInputVal = "";
        },
        deselectLinks(val){
            let optionsIndexToDeselect = this.choosenLinksMultiselectArray[0].options.findIndex((options) => {
                return options.value == val;
            });
            this.choosenLinksMultiselectArray[0].options.splice(optionsIndexToDeselect, 1);
            this.addLinkInputVal = "";
        },
        addOrCorrectNewsHandler(){
            // let isTitleValid = this.$helper.checkString(this.addOrCorrectNews.title);
            // let isBodyTextValid = this.$helper.checkString(this.addOrCorrectNews.body_text);
            // let isTitleEngValid = this.$helper.checkEngString(this.addOrCorrectNews.titleeng);
            // let isBodyTextEngValid = this.$helper.checkEngString(this.addOrCorrectNews.body_texteng);
            // console.log(isTitleValid);
            // console.log(isBodyTextValid);
            // console.log(isTitleEngValid);
            // console.log(isBodyTextEngValid);
            // console.log(isNewsDateValid);
            // console.log(isPublishDateValid);
            // console.log(isIsMainValid);
            
            let isNewsDateValid = this.$helper.checkDateWithRegex(this.addOrCorrectNews.news_date);
            let isIsMainValid = (this.addOrCorrectNews.is_main === true || this.addOrCorrectNews.is_main === false)?true:false;
            let isPhotoValid = this.$helper.checkPhotoFormat(this.$refs?.activityOrNewsPhoto?.files[0], ['image/jpeg', 'image/png']);
            let isPhotoValidAndRequired = this.modalMode.startsWith("add")?isPhotoValid:(isPhotoValid || this.$refs?.activityOrNewsPhoto?.files.length == 0);
            
            this.isTitleSet = JSON.stringify(this.addOrCorrectQuillTitle.root.innerText) !== JSON.stringify("\n");
            this.isTitleengSet = JSON.stringify(this.addOrCorrectQuillTitleeng.root.innerText) !== JSON.stringify("\n");
            this.isBodyTextSet = JSON.stringify(this.addOrCorrectQuillBodyText.root.innerText) !== JSON.stringify("\n");
            this.isBodyTextengSet = JSON.stringify(this.addOrCorrectQuillBodyTexteng.root.innerText) !== JSON.stringify("\n");
            
            if(isPhotoValidAndRequired && (this.isTitleSet || this.isTitleengSet) && (this.isBodyTextSet || this.isBodyTextengSet)
                && isNewsDateValid && isIsMainValid){

                let formData = new FormData();
                Object.keys(this.addOrCorrectNews).forEach((key) => {
                    if(key == "is_main"){
                        let val = this.addOrCorrectNews[key]?1:0;
                        formData.append(key, val);
                    }else if(key == "tags"){
                        let combinedStr = this.addOrCorrectNews[key]?this.addOrCorrectNews[key].join(","):"";
                        formData.append(key, combinedStr);
                    }else if(key == "news_links"){
                        let linksArr = [];
                        this.choosenLinksMultiselectArray[0].options.forEach((linkOptionObj) => {
                            linksArr?.push({
                                news_link: linkOptionObj.value,
                                link_typeID: linkOptionObj.link_typeID,
                            });
                        });
                        formData.append("news_links", JSON.stringify(linksArr));
                    }else if(key == "news_date"){
                        formData.append(key, this.addOrCorrectNews[key]);
                    }
                });
                formData.append('title', this.addOrCorrectQuillTitle.root.innerHTML.trim());
                formData.append('titleeng', this.addOrCorrectQuillTitleeng.root.innerHTML.trim());
                formData.append('body_text', this.addOrCorrectQuillBodyText.root.innerHTML.trim());
                formData.append('body_texteng', this.addOrCorrectQuillBodyTexteng.root.innerHTML.trim());

                formData.append('news_photo', (this.$refs?.activityOrNewsPhoto?.files[0])??null);

                let word;
                if(this.modalMode.startsWith("add")){
                    formData.append('news_typeID', this.modalMode == "addActivity"?2:1);
                    word = this.modalMode == "addActivity"?"აქტივობა":"სიახლე";
                }else if(this.modalMode.startsWith("correct")){
                    formData.append('newsID', this.openedNews.openedNewsID);
                    formData.append('news_typeID', this.modalMode == "correctActivity"?2:1);
                    word = this.modalMode == "correctActivity"?"აქტივობა":"სიახლე";
                }
                const date = new Date().toLocaleString("sv-SE");
                formData.append('publish_date', date);
                
                // for(let entries of formData.entries()){
                //     console.log(entries);
                // }
                // console.log(word);
                if(this.modalMode.startsWith("add")){
                    this.$store.dispatch("addNews", formData).then((response) => {
                        if(response.status == 201){
                            this.$helper.showSwal(`${word} წარმატებით დაემატა`, "success", "");
                            this.triggerModal(false);
                            this.getActivities();
                            this.getNews();
                        }
                    }).catch((error) => {
                        if(error?.response?.status == 422){
                            this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                            this.triggerModal(false);
                            this.getActivities();
                            this.getNews();
                        }
                    });
                }else if(this.modalMode.startsWith("correct")){
                    
                    this.$store.dispatch("editNews", formData).then((response) => {
                        
                        if(response.status == 204){
                            this.$helper.showSwal(`${word} წარმატებით ჩასწორდა`, "success", "");
                            this.triggerModal(false);
                            this.getActivities();
                            this.getNews();
                        }
                    }).catch((error) => {
                        if(error?.response?.status >= 400){
                            
                            this.$helper.showSwal(`მოხდა შეცდომა: ${error?.response?.statusText}`, "error", "");
                            this.triggerModal(false);
                            this.getActivities();
                            this.getNews();
                        }
                    });
                }
                
            }
        },
        manageNewsFilters(){
            Object.keys(this.newsFiltersInfoObj).forEach((key) => {
                if(key == "search"){
                    this.newsFiltersInfoObj[key] = this.filteringPagingInfo[`news${key}`];
                }else if(key == "date"){
                }else if(this.filteringPagingInfo[`news${key}`]){
                    this.newsFiltersInfoObj[key] = Number(this.filteringPagingInfo[`news${key}`]);
                }else{
                    this.newsFiltersInfoObj[key] = this.filteringPagingInfo[`news${key}`];
                }
            })
            this.newsFiltersInfoObj.dateSort = (this.newsFiltersInfoObj.dateSort == 1 || this.newsFiltersInfoObj.dateSort == 2)?this.newsFiltersInfoObj.dateSort:1;
            
            this.newsPagingInfo.offset = this.filteringPagingInfo.newsOffset?(Number(this.filteringPagingInfo.newsOffset) + 1):1;
            this.getNews();
        },
        submitNewsFilters(){
            let tempObj = {};
            if(this.$route.query.newsOffset){
                tempObj.newsOffset = 0;
            }
            Object.keys(this.newsFiltersInfoObj).forEach((key) => {
                if((this.newsFiltersInfoObj[key] || this.newsFiltersInfoObj[key] === 0) && key != "date"){
                    tempObj[`news${key}`] = this.newsFiltersInfoObj[key];
                }
            })
            this.activatedFilterMode = 2;
            let filteredQueries = {};
            Object.keys(this.$route.query).forEach((queryKey) => {
                if(this.newsFiltersInfoObj.hasOwnProperty(`${queryKey.slice(4)}`) && queryKey.startsWith("news")){
                }else{
                    filteredQueries[queryKey] = this.$route.query[queryKey];
                }
            })
            
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...filteredQueries,
                    ...tempObj,
                }
            });
        },
        manageActivitiesFilters(){
            Object.keys(this.activitiesFiltersInfoObj).forEach((key) => {
                if(key == "search"){
                    this.activitiesFiltersInfoObj[key] = this.filteringPagingInfo[`activities${key}`];
                }else if(key == "date"){
                }else if(this.filteringPagingInfo[`activities${key}`]){
                    this.activitiesFiltersInfoObj[key] = Number(this.filteringPagingInfo[`activities${key}`]);
                }else{
                    this.activitiesFiltersInfoObj[key] = this.filteringPagingInfo[`activities${key}`];
                }
            })
            this.activitiesFiltersInfoObj.dateSort = (this.activitiesFiltersInfoObj.dateSort == 1 || this.activitiesFiltersInfoObj.dateSort == 2)?this.activitiesFiltersInfoObj.dateSort:1;
            
            this.activitiesPagingInfo.offset = this.filteringPagingInfo.activitiesOffset?(Number(this.filteringPagingInfo.activitiesOffset) + 1):1;
            this.getActivities();
        },
        submitActivitiesFilters(){
            let tempObj = {};
            if(this.$route.query.activitiesOffset){
                tempObj.activitiesOffset = 0;
            }
            Object.keys(this.activitiesFiltersInfoObj).forEach((key) => {
                if((this.activitiesFiltersInfoObj[key] || this.activitiesFiltersInfoObj[key] === 0) && key != "date"){
                    tempObj[`activities${key}`] = this.activitiesFiltersInfoObj[key];
                }
            })
            this.activatedFilterMode = 1;
            let filteredQueries = {};
            Object.keys(this.$route.query).forEach((queryKey) => {
                if(this.activitiesFiltersInfoObj.hasOwnProperty(`${queryKey.slice(10)}`) && queryKey.startsWith("activities")){
                }else{
                    filteredQueries[queryKey] = this.$route.query[queryKey];
                }
            })
            
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...filteredQueries,
                    ...tempObj,
                }
            });
        },
        getActivities(){
            this.$store.dispatch("getNews", {search: this.activitiesFiltersInfoObj.search, activitiesdateSort: this.activitiesFiltersInfoObj.dateSort , news_typeID: 2, offset: this.activitiesPagingInfo.offset - 1, limit: this.activitiesPagingInfo.limit}).then((response) => {
                this.activitiesArray = response.data[0];
                this.activitiesPagingInfo.total = response.data[1];
            });
        },
        getNews(){
            this.$store.dispatch("getNews", {search: this.newsFiltersInfoObj.search, activitiesdateSort: this.newsFiltersInfoObj.dateSort , news_typeID: 1, offset: this.newsPagingInfo.offset - 1, limit: this.newsPagingInfo.limit}).then((response) => {
                this.newsArray = response.data[0];
                this.newsPagingInfo.total = response.data[1];
            });
        },
        getLinkTypes(){
            this.$store.dispatch("getLinkTypes").then((response) => {
                this.linkTypes = response.data;

                this.linkTypes.forEach((linkObj) => {
                    this.linksMultiselectArray[0].options.push({
                        value: linkObj.link_typeID,
                        label: linkObj.link_type,
                        icon: linkObj.icon,
                    });
                });
            });
        },
        newsPaginationClickHandler(value){
            this.activatedFilterMode = 2;

            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query, 
                    newsOffset: value - 1,
                }
            });
        },
        activitiesPaginationClickHandler(value){
            this.activatedFilterMode = 1;

            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query, 
                    activitiesOffset: value - 1,
                }
            });
        },
        removeAriaHidden(){
            Array.from(document.querySelectorAll('.multiselect span[aria-hidden]')).forEach((item) => {
                item.removeAttribute('aria-hidden');
            })
            Array.from(document.querySelectorAll('.multiselect .multiselect-tags-search[aria-labelledby]')).forEach((item) => {
                item.removeAttribute('aria-labelledby');
            })
        },
    },
}
</script>
<style scoped>
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, min-content);
  row-gap: 2em;
}
/* for common secondary search conatainer >> */
.common-secondary-search-container{
    padding: 1em;
    border-radius: 10px;
    width: 100%;
    background-color: var(--secondary-background-color);
}
.common-secondary-search-container .search-form{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1em;
}
.common-secondary-search-container .primary-input{
    max-width: 520px;
}
.add-or-correct-form .multiselect.with-no-options{
    --ms-max-height: 0;
}

.links-list-grid-wrapper{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5em;
}
.tags-and-links{
    padding: 0.3em 0.5em;
    background-color: var(--light-blue);
    border-radius: 5px;
    color: var(--secondary-background-color);
}
.tags-and-links.default{
    background-color: var(--middle-gray);
}
.modal-form-grid-wrapper .blue-part-input{
    padding: 0.6em;
}
.modal-form-grid-wrapper{
    gap: 0.7em;
    place-items: stretch;

}
.modal-form-grid-wrapper fieldset{
    height: 100%;
}
.modal-form-grid-wrapper li:not(.tags-and-links){
    height: 100%;
}
.see-news-modal-form-grid-wrapper{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: min-content;
    gap: 1em;
    margin-bottom: 10em;
}
.see-news-modal-form-grid-wrapper .blue-part-input{
    max-width: none;
}

/* quill validation styles >>>> */

.ql-editor.ql-blank::before{
    inset: auto !important;
}
.ql-container.ql-snow{
    border: 1px solid #ccc;
}
.red-border .ql-container.ql-snow{
    border: 1px solid red !important;
}
.newsOrActivityTitle *{
    color: var(--extra-black) !important;
}
/* <<<< quill validation styles */
@media screen and (max-width: 1800px) {
    .common-secondary-search-container .primary-input{
        max-width: 400px;
    }
    .modal-form-grid-wrapper{
        gap: 0.7em;
    }
    .modal-form-grid-wrapper .blue-part-input{
        padding: 0.8em;
    }
}
@media screen and (max-width: 1560px) {
    .common-secondary-search-container .primary-input{
        max-width: 300px;
    }
    .modal-form-grid-wrapper{
        gap: 0.4em;
    }
    .modal-form-grid-wrapper .blue-part-input{
        padding: 0.6em;
    }
}
</style>